import React from 'react';
import AtlasV2DorisSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisSplineChart';
import { BeaconSubtitleContainer } from 'src/components/BeaconV2Components/BeaconChartWithLegend/BeaconSubtitleContainer';
import SubtitleFilters from 'src/components/Charts/SubtitleFilters';
import { useMainTimePeriodShortDisplayName } from 'src/utils/Hooks/typedHooks';
import { useComparisonTimePeriodShortDisplayName } from 'src/utils/Hooks/typedHooks';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import SplineChartLoading from 'src/components/BeaconV2Components/SplineChartLoading/SplineChartLoading';
import {
  useEntityPhrasing,
  useTaxonomySubtitleText
} from 'src/components/BeaconV2Components/common/BeaconProDynamicSubtitle/hooks';
const AtlasV2OtherTrafficV2ProductWithOtherTraffic = () => {
  const mainTimePeriodShortDisplayName = useMainTimePeriodShortDisplayName();
  const comparisonTimeDisplayName = useComparisonTimePeriodShortDisplayName();
  const entityPhrase = useEntityPhrasing();
  const taxonomyText = useTaxonomySubtitleText();

  return (
    <AtlasV2DorisSplineChart
      queryKey="otherTrafficKeywordCountSplineChart"
      title="Products with Other Traffic"
      metricTypeDisplay={METRICTYPE.VOLUME}
      showLastWeekValue
      metricType="ProductsWithOtherTrafficCount"
      beaconChartWithLegendOverride={(props) => {
        return {
          ...props,
          includeSummaryInfo: false,
          loadingComponent: <SplineChartLoading includeSubtitle />,
          subtitle: (
            <BeaconSubtitleContainer>
              <Text variant="body1" lineHeight="24px">
                {`The chart displays the number of products that generated other traffic for ${entityPhrase} ${taxonomyText} during the 
            ${mainTimePeriodShortDisplayName} period compared to the ${comparisonTimeDisplayName}.`}
                <SubtitleFilters showFilterNumber={false} />
              </Text>
            </BeaconSubtitleContainer>
          )
        };
      }}
    />
  );
};
export default AtlasV2OtherTrafficV2ProductWithOtherTraffic;
